export function getECargoEnvironment() {
    switch(window.location.hostname.toLowerCase()) {
        case 'www.ecargo.co.nz':
        case 'ecargo.co.nz':
            return 'production';
            break;
        case 'test.ecargo.co.nz':
            return 'uat'
            break;
        default:
            return 'development';
    }
}
